// extracted by mini-css-extract-plugin
var _1 = "aYa0HCgrwI";
export { _1 as "root" }
